import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = {
  class: "table table-row-dashed fs-6 gy-5 my-0",
  id: "kt_ecommerce_add_product_reviews"
}
const _hoisted_10 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }

import { inject, onMounted, reactive, ref, Ref } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import AccountService from "../services/AccountService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import { ElNotification } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'KycForm',
  emits: ["submit"],
  setup(__props, { emit: emits }) {



const isLoading = ref(true);

const getUserInfos = inject<() => object>(
  AccountInjectionKeys.GET_USER_INFOS,
  () => ({})
);
const userInfos = ref<any>({});

const accountDetails = inject<Ref>(
  AccountInjectionKeys.ACCOUNT_DETAILS,
  ref<any>({})
);

const ruleFormRef = ref<FormInstance>();

const kycInfos = ref({} as any);

const rules = reactive<FormRules>({});

const submitForm = async () => {
  try {
    /**
     * if kycRecords exists, means the user has submitted the form before,
     * update the form to awaiting review status
     * allowing compliance staff to re-review the form
     */
    if (kycInfos.value.emptyKycForm && kycRecords.value.length === 0) {
      try {
        await AccountService.createKycForm(
          userInfos.value.partyId,
          kycInfos.value
        );
      } catch (error) {
        MsgPrompt.error(error);
      }
    } else {
      await AccountService.updateKycFormToAwaitingReview(
        userInfos.value.partyId
      );
    }
    ElNotification({
      title: "Success",
      message: "KYC Form Submit Success",
      type: "success",
    });
    // MsgPrompt.success("Submit Success");
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: e.response.data.message
        ? e.response.data.message
        : "Error Submit",
      type: "error",
    });
    // MsgPrompt.error(error);
  }
  emits("submit");
};

const resetForm = async () => {
  if (!ruleFormRef.value) return;
  const _kycInfo = await UserService.getPredefinedKycInfos(
    userInfos.value.partyId
  );
  kycInfos.value = {
    ..._kycInfo,
    accountNumber: accountDetails.value.tradeAccount?.accountNumber,
  };
};

const kycRecords = ref(Array<any>());

const criteria = ref({
  page: 1,
  size: 10,
});
const fetchKycHistory = async (_page: number) => {
  criteria.value.page = _page;
  kycRecords.value = await AccountService.getUserKycHistory(
    userInfos.value.partyId
  );
};

onMounted(async () => {
  userInfos.value = await getUserInfos();
  await resetForm();
  await fetchKycHistory(1);
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("tip.kycForm")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          rules: rules,
          "label-width": "150px",
          class: "demo-ruleForm",
          size: "default",
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Account",
              prop: "account"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: kycInfos.value.accountNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((kycInfos.value.accountNumber) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "First Name",
              prop: "firstName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: kycInfos.value.firstName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((kycInfos.value.firstName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "LastName",
              prop: "lastName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: kycInfos.value.lastName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((kycInfos.value.lastName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "ID Issue Date",
              prop: "idIssueDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: kycInfos.value.idIssuedOn,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((kycInfos.value.idIssuedOn) = $event)),
                  type: "date",
                  label: "Pick a date",
                  placeholder: _ctx.$t('action.select'),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Issue Office",
              prop: "issueOffice"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: kycInfos.value.idIssuer,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((kycInfos.value.idIssuer) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Expiration Data",
              prop: "expirationDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: kycInfos.value.idExpireOn,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((kycInfos.value.idExpireOn) = $event)),
                  type: "date",
                  label: "Pick a date",
                  placeholder: _ctx.$t('action.select'),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Address",
              prop: "address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: kycInfos.value.address,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((kycInfos.value.address) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  loading: isLoading.value,
                  type: "primary",
                  onClick: submitForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Preview")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("tip.kycRecord")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_10, [
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.staff")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.complianceStaff")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && kycRecords.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kycRecords.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.accountNumber), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.staffPartyId), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.complianceName), 1)
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          "page-change": fetchKycHistory,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ])
  ]))
}
}

})